<template>
 <div class="pageIndex">
<!--   <new-year-video-comp></new-year-video-comp>-->
    <div class="bannerbox"></div>
    <div class="banner" @click="handleBannerClick">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in images"
            :key="index"
            :data-index="index"
          >
          <img :src="item.imgUrl" alt="" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>

      <!-- <div class="imgbox">
        <div class="slogan-text">{{ slogan }}</div>
         <img src="@/assets/img/solagan.png" alt="" class="titleimg" /> 
         <img src="@/assets/img/cycle1-1.png" alt="" class="cycle1-1" /> 
        <img src="@/assets/img/cycle2.png" alt="" class="cycle2"   /> 
        <img src="@/assets/img/cycle2.png" alt="" class="cycle2-1" />
        <img src="@/assets/img/cycle1-2.png" alt="" class="cycle1-2" />
        <img src="@/assets/img/cycle1.png" alt="" class="cycle1" />
        <img src="@/assets/img/cycle1.png" alt="" class="cycle1_1" />

      </div> -->
    </div>

    
    <!-- 动态模块区域 -->
    <template v-for="(module, moduleIndex) in moduleOrder">
      <div class="box" :class="{'news animate-up': module.moduleKey === 'new' || module.moduleKey === 'special', 'moreBox': module.moduleKey === 'partner'}" :key="module.id" v-if="module.status">
        <div class="title animate-up" >{{ module.moduleName }}</div>
        
        <!-- 公司新闻内容 -->
        <div class="flexrow" v-if="module.moduleKey === 'new'">
          <div
            class="newsbox"
            v-for="(item, index) in newslists"
            :key="index"
            v-if="index < 3"
            @click="showNews(item)"
          >
            <div class="imgbox">
              <img :src="item.backGroundImages[0].previewUrl" alt="" />
            </div>
            <h1
              @mouseenter="newsHover(item, true)"
              @mouseleave="newsHover(item, false)"
            >
              {{ item.title }}
            </h1>
            <p>{{ item.releaseDate?.split(" ")[0] }}</p> 
            <div
              class="righticon"
              :class="item.isHover ? 'righticon2' : ''"
            ></div>
          </div>
          <div class="newsbox" @click="goNews">
            <div class="imgbox">
              <img src="@/assets/img/morenews.jpg" alt="" />
            </div>
            <h1
              class="more"
              @mouseenter="isHover = true"
              @mouseleave="isHover = false"
            >
              查看更多资讯
            </h1>
            <div class="righticon" :class="isHover ? 'righticon2' : ''"></div>
          </div>
        </div>
        
        <!-- 华凤企业宣传片内容 -->
        <div v-if="module.moduleKey === 'publicize'">
          <div class="videobox" v-for="(item, index) in dataList" :key="index">
            <iframe
              title=""
              width="100%"
              height="100%"   
              :src="item.video"
              frameborder="0"
              loading="lazy"
              seamless
              allowfullscreen
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            ></iframe>
          </div>
        </div>
        
        <!-- 合作伙伴内容 -->
        <div v-if="module.moduleKey === 'partner'">
          <div class="imgFlexBox animate-up">
            <div 
              class="imgbox" 
              v-for="(item, index) in partnerList" 
              :key="index" 
              v-if="index < 8 || showMore" 
              @click="openPartnerLink(item)"
            >
              <img :src="item.imgUrl" alt="" style="cursor: pointer;"/>
            </div>
          </div>
          <div class="moreTip" @click="showMore = !showMore" v-show="!showMore && partnerList.length > 8">
            更多合作伙伴
          </div>
        </div>


        <!-- 专题模块 -->
        <div v-if="module.moduleKey === 'special'">
  <div class="flexrow animate-up">
    <div 
      class="newsbox"
      v-for="(item, index) in specialList"
      :key="index"
      @click="handleSpecialClick(item)"
    >
      <div class="imgbox">
        <img :src="item.specialCover" alt="" />
      </div>
      <h1
        @mouseenter="specialHover(item, true)"
        @mouseleave="specialHover(item, false)"
      >
        {{ item.specialName }}
      </h1>
      <p>{{ item.specialDesc || '' }}</p>
      <div
        class="righticon"
        :class="item.isHover ? 'righticon2' : ''"
      ></div>
    </div>
  </div>
</div>
      
      </div>
    </template>

    


    <!-- 动态模块标题区域 - 显示索引3及以上的标题 -->
    <div 
      class="box dynamicModuleBox" 
      v-for="module in dynamicModules" 
      :key="module.id"
      v-if="module.status && module.moduleName && false"
    >
      <div class="title animate-up">{{ module.moduleName || '默认标题' }}</div>

    </div>


<!-- 测试 -->
<!-- <div
  class="box dynamicModuleBox"
  v-for="module in dynamicModules"
  :key="module.id"
  style="border:1px solid red;color:red"
>
  {{ module.moduleName }}
</div> -->


<!-- 底部间距 -->
 <div class="bottom-spacing"></div>


    <!-- 底部区域 -->
    <footer-bar class="animate-up"></footer-bar>

    <!-- 视频弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      custom-class="videoDialog"
      :close-on-click-modal="false"
      @open="stopSrcoll"
      @close="openSrcoll"
      destroy-on-close
      top="7vh"
    >
      <video :src="videoData" autoplay controls></video>
    </el-dialog>

    <!-- 新闻详情弹窗 -->
    <el-drawer
      :visible.sync="drawer"
      size="50%"
      @open="stopSrcoll"
      @close="openSrcoll"
    >
      <div class="drawer" v-if="drawer">
        <div class="drawer_title">
          {{ drawerNew.title }}
        </div>
        <div class="name">华凤技术（南京）有限公司</div>
        <div class="time">{{ drawerNew.releaseDate }}</div>
        <div class="drawer_content" v-html="drawerNew.newsContent"></div>
      </div>
    </el-drawer>

<!-- 专题详情抽屉 -->
<el-drawer
  :visible.sync="specialDrawer"
  size="50%"
  @open="stopSrcoll"
  @close="openSrcoll"
>
  <div class="drawer" v-if="specialDrawer">
    <div class="drawer_title">
      {{ currentSpecial.specialName }}
    </div>
    <div class="name">华凤技术（南京）有限公司</div>
    <div class="time" v-if="currentSpecial.specialDesc">{{ currentSpecial.specialDesc }}</div>
    
    <!-- 图片类型 -->
    <div v-if="currentSpecial.specialType === '1'" class="drawer_content">
      <img :src="currentSpecial.specialContent" alt="" style="max-width: 100%;" />
    </div>
    
    <!-- 富文本类型 -->
    <div v-if="currentSpecial.specialType === '2'" class="drawer_content" v-html="currentSpecial.specialContent"></div>
  </div>
</el-drawer>




    
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
// import newYearVideoComp from "@/components/newYearVideoComp.vue"
export default {
  components: {
    Swiper,
    // newYearVideoComp
  },
  data() {
    return {
      showMore: false,
      dialogVisible: false,
      dataList: [],
      videoData: "",
      newslists: [],
      drawer: false,
      drawerNew: {},
      slogan: "",
      partnerList: [],
      moduleOrder: [],
      specialList: [],
      specialDrawer: false,
      currentSpecial: {},
      images: [
        // {
        //   src: require("@/assets/img/1-img.jpg"),
        // },
        // {
        //   src: require("@/assets/img/2-img.jpg"),
        // },
        // {
        //   src: require("@/assets/img/3-img.jpg"),
        // },
        // {
        //   src: require("@/assets/img/4-img.jpg"),
        // },
      ],
      currentIndex: 0,
      intervalId: null,
      isHover: false,
      imgList: [
        {
          src: require("@/assets/img/icon_1.png"),
        },
        {
          src: require("@/assets/img/icon_2.png"),
        },
        {
          src: require("@/assets/img/icon_3.png"),
        },
        {
          src: require("@/assets/img/icon_4.png"),
        },
        {
          src: require("@/assets/img/icon_5.png"),
        },
        {
          src: require("@/assets/img/icon_6.png"),
        },
        {
          src: require("@/assets/img/icon_7.png"),
        },
        {
          src: require("@/assets/img/icon_8.png"),
        },
        {
          src: require("@/assets/img/icon_9.png"),
        },
        {
          src: require("@/assets/img/icon_10.png"),
        },
        {
          src: require("@/assets/img/icon_11.png"),
        },
        {
          src: require("@/assets/img/icon_12.png"),
        },
        {
          src: require("@/assets/img/icon_13.png"),
        },
      ],
    };
  },

  beforeDestroy() {
    this.dialogVisible = false;
    clearInterval(this.intervalId);
  },
  mounted() {
    this.openSrcoll();
    this.getData();

    this.swiper = new Swiper(".swiper-container", {
      // 可选的配置参数，根据需要进行配置
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 1200,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      // effect: "fade",
    });

    this.$nextTick(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            // 可选：当元素离开视口时移除active类
            // entry.target.classList.remove("active");
          }
        });
      }, {
        threshold: 0.1 // 元素10%可见时触发
      });  

      // 初始观察所有animate-up元素
      document.querySelectorAll(".animate-up").forEach((element) => {
        observer.observe(element);
      });
    });
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex].src;  
    },
    dynamicModules() {
      const modules = this.moduleOrder.slice(3).filter(m => m.status && m.moduleName);
      console.log("最终显示的 dynamicModules：", modules);
      
      // 在动态模块更新后，重新注册IntersectionObserver
      this.$nextTick(() => {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("active");
            }
          });
        });
        
        document.querySelectorAll(".animate-up").forEach((element) => {
          observer.observe(element);
        });
      });
      
      return modules;
    }
  },
  methods: {

    // 获取专题类型文本
  getSpecialTypeText(type) {
    switch(type) {
      case "1": return "图片";
      case "2": return "文本";
      case "3": return "链接";
      default: return "其他";
    }
  },
 // 专题悬停效果
 specialHover(item, flag) {
    this.$set(item, "isHover", flag);
  },

// 处理专题点击
  handleSpecialClick(item) {
    // 根据specialType处理不同的点击事件
    if (item.specialType === "3") {
      // 跳转链接类型
      if (item.specialContent) {
        window.open(item.specialContent, '_blank');
      }
    } else {
      // 图片类型和富文本类型都显示在抽屉中
      this.currentSpecial = item;
      this.specialDrawer = true;
    }
  },



    getModuleByKey(key) {
      // 去除可能的空格
      const trimmedKey = key.trim();
      return this.moduleOrder.find(item => item.moduleKey.trim() === trimmedKey);
    },
    
    getModuleByIndex(index) {
      return this.moduleOrder.length > index ? this.moduleOrder[index] : null;
    },

 

    openPartnerLink(item) {
  if (item.jumpLink) {
    window.open(item.jumpLink, '_blank');
  }
},


//点击Banner跳转
handleBannerClick() {
  const activeIndex = this.swiper ? this.swiper.activeIndex : 0;
  // 考虑到loop模式，需要处理真实索引
  let realIndex = activeIndex;
  if (this.swiper && this.swiper.params.loop) {
    realIndex = this.swiper.realIndex;
  }
  
  const currentSlide = this.images[realIndex];
  if (currentSlide && currentSlide.jumpLink) {
    // 判断链接类型
    if (currentSlide.jumpLink.startsWith('http://') || currentSlide.jumpLink.startsWith('https://')) {
      // 外部链接，使用window.open打开
      window.open(currentSlide.jumpLink, '_blank');
    } else if (currentSlide.jumpLink.startsWith('/')) {
      // 内部路由，使用router.push跳转
      this.$router.push(currentSlide.jumpLink);
    }
  }
},







    getData() {
      this.$api.selectNews({ type: 0 }).then((res) => {
        this.newslists = res ? res : [];
        this.newslists.forEach((item) => {
          item.releaseDate = this.timestampToDate(item.releaseDate);
        });
      });
      this.$api.companyCoreTechnologySelectAll().then((res) => {
        this.dataList = res;
        console.log(this.dataList, "dataList111111111111111");
      });
      //查询首页Banner
      this.$api.selectBanner().then((res) => {
        this.images = res || []; 
        console.log(this.images, "bannerList");
        // 初始化轮播图
        this.$nextTick(() => {
          if (this.swiper) {
            this.swiper.destroy();
          }
          this.initSwiper();
        });
      });
     //查询首页slogan
    this.$api.selectSlogan().then((res) => {
  console.log(res, "slogan");
  // 找到总部的slogan (isHeadquarters=1)
  const headquartersItem = res.find(item => item.isHeadquarters == 1);
  if (headquartersItem) {
    // 直接赋值字符串，而不是数组
    this.slogan = headquartersItem.slogan;
  } else {
    // 如果没找到总部的slogan，设置默认值
    this.slogan = "";
  }
    });
    //查询首页合作伙伴
     this.$api.selectPartner().then((res) => {
     console.log(res, "合作伙伴");
    this.partnerList = res || [];
  
  // 如果需要按sort字段排序
  this.partnerList.sort((a, b) => {
    return (a.sort || 0) - (b.sort || 0);
  });
    });
    //查询首页模块顺序
    this.$api.selectModuleOrder().then((res) => {
     console.log(res, "模块顺序");
     this.moduleOrder = res || [];
     
     // 根据sortOrder字段排序
     this.moduleOrder.sort((a, b) => {
       return (a.sortOrder || 0) - (b.sortOrder || 0);
     });
     
     // 检查是否有index >= 3的数据
     console.log("是否有index >= 3的数据:", this.moduleOrder.length > 3);
     if (this.moduleOrder.length > 3) {
       console.log("index >= 3的数据:", this.moduleOrder.slice(3));
     }
   });
  //查询专题模块
this.$api.selectSpecialModule().then((res) => {
  console.log(res, "专题模块");
  this.specialList = res || [];
  
  // 如果需要按specialSort字段排序
  this.specialList.sort((a, b) => {
    return (a.specialSort || 0) - (b.specialSort || 0);
  });
});
    },
    initSwiper() {
      this.swiper = new Swiper(".swiper-container", {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
      });
    },
   
    stopSrcoll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.documentElement.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },

    openSrcoll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.documentElement.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    goNews() {
      this.$router.push({
        path: "/companyNews",
      });
    },
    showNews(item) {
      this.drawerNew = item;
      this.drawer = true;
    },
    timestampToDate(timestamp) {
      const date = new Date(timestamp); // 时间戳通常是以秒为单位的，需要乘以1000转换为毫秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的，所以需要加1
      const day = String(date.getDate()).padStart(2, "0");
      const hours = ("0" + date.getHours()).slice(-2);
      const minutes = ("0" + date.getMinutes()).slice(-2);
      const seconds = ("0" + date.getSeconds()).slice(-2);
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    newsHover(item, flag) {
      this.$set(item, "isHover", flag);
    },
    newsHover2(item, flag) {
      this.$set(this, "isHover", flag);
    },
  },
};
</script>

<style lang="less" scoped>
.pageIndex {
  padding: 0;
  .box {
    .title {
      padding: 170px 0 80px;
      font-size: 48px;
      font-weight: 400;
      color: #fff;
      text-align: center;
      font-weight: 700;
    }
    .flexrow {
      display: flex;
      width: 100%;
      .flexbox {
        flex: 1;
      }
    }
    .videobox {
      height: 800px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-size: 100% 100%;
      position: relative;
      margin-bottom: 80px;
      &:last-child {
        margin-bottom: 0;
      }
      div {
        display: flex;
        align-items: center;
      }
      h1 {
        display: inline-block;
        font-size: 48px;
        line-height: 64px;
        font-weight: 400;
        color: #fff;
        z-index: 99;
      }
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 60px;
        line-height: 64px;
        height: 64px;
        text-align: center;
        font-weight: 400;
        color: #fff;
        margin: 0 24px;
        position: relative;
        top: -4px;
      }

      .play {
        position: absolute;
        bottom: 40px;
        left: 50px;
        width: 99px;
        cursor: pointer;
      }

      .bgimg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
      }
    }
    .videobox_1 {
      background-image: url("~@/assets/img/index_bg_1.jpg");
    }
    .videobox_2 {
      background-image: url("~@/assets/img/index_bg_2.jpg");
    }
    .videobox_3 {
      background-image: url("~@/assets/img/index_bg_3.jpg");
    }
    .imgFlexBox {
  display: flex;
  padding: 0 80px;
  flex-wrap: wrap;
  .imgbox {
    width: 240px;
    height: 100px;
    margin: 0 calc((100% - 960px) / 3) 64px 0; 
    box-sizing: border-box;
    
    img {
      display: block;
      width: 100%;
      height: 100%;
      margin: auto;
    }
    
    /* 每行4个，第4个没有右边距 */
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}









  }
  .swiper-slide {
    position: relative;
    
    .banner-link {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 99999; /* 确保高于遮罩层 */
      cursor: pointer;
    }
  }
















  .moreBox {
    padding: 0 0 160px;
    text-align: center;
    // border-bottom: 1px solid #8892a1;
    .moreTip {
      display: inline-block;
      font-size: 20px;
      color: #fff;
      line-height: 20px;
      text-align: center;
      cursor: pointer;
      width: auto;
      border-bottom: 1px solid #fff;
      padding: 0 0 4px;
      &:hover {
        color: #009ade;
        border-color: #009ade;
      }
    }
  }

  .bannerbox {
    height: 100vh;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .text {
      position: relative;
      z-index: 222;
      color: #fff;
      bottom: -50px;
      opacity: 0;
      animation: fade-in-from-bottom 1.5s ease-out forwards;
      h1 {
        font-size: 56px;
        line-height: 84px;
        font-family: "AlimamaShuHeiTi-Bold";
        font-weight: normal;
      }
    }
  }
  .slogan-text {
  position: absolute;
  color: #fff;
  font-size: 50px;
  font-weight: 700;
  text-align: center;
  width: 100%;
  top: calc(50% - 50px); 
  z-index: 100;
  font-family: "AlimamaShuHeiTi-Bold", "Microsoft YaHei", "SimHei", sans-serif; 
  letter-spacing: 2px; 
}



  .banner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    cursor: pointer;
    // width: 1920px;
    // height: 1080px;
    .video {
      width: 1920px;
      height: 100%;
    }
    video {
      width: 1920px;
      height: 100%;
      object-fit: cover;
    }
    .imgbox {
      position: absolute;
      width: 100vw;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 0;
      left: 0;
      z-index: 99;
      .titleimg {
        width: 943px;
        height: 40px;
        margin-top: 100px;
      }
      .cycle1-1 {
        position: absolute;
        width: 57px;
        height: 60px;
        top: 45vh;
        left: 20vw;
        animation: rotate 5s linear infinite;
      }

      .cycle2 {
        position: absolute;
        width: 76px;
        height: 73px;
        top: 60vh;
        left: 31.5vw;
        animation: rotate 5s linear infinite;
      }

      .cycle2-1 {
        position: absolute;
        width: 76px;
        height: 73px;
        top: 35vh;
        left: 75vw;
        animation: rotate 5s linear infinite;
      }

      .cycle1-2 {
        position: absolute;
        width: 76px;
        height: 73px;
        top: 65vh;
        left: 55vw;
        animation: rotate 5s linear infinite;
      }

      .cycle1 {
        position: absolute;
        width: 37px;
        height: 40px;
        top: 35vh;
        left: 32vw;
        animation: rotate 5s linear infinite;
      }

      .cycle1_1 {
        position: absolute;
        width: 37px;
        height: 40px;
        top: 38vh;
        left: 64vw;
        animation: rotate 5s linear infinite;
      }

      .index_icon {
        position: absolute;
        width: 24px;
        height: 24px;
        top: 40vh;
        left: 56vw;
      }

      .index_icon2 {
        position: absolute;
        width: 18px;
        height: 18px;
        top: 60vh;
        left: 63.5vw;
      }

      @keyframes rotate {
        from {
          transform: rotate(0deg); /* 从0度开始旋转 */
        }
        to {
          transform: rotate(360deg); /* 旋转360度，即一圈 */
        }
      }
      // 专题模块专用动画
@keyframes specialFlyIn {
  from {
    right: 60px;
    opacity: 0;
  }
  to {
    right: 24px;
    opacity: 1;
  }
}
    }
  }

  .news {
    .newsbox {
      margin: 0 0 0 30px;
      &:nth-child(1) {
        margin-left: 0;
      }
      width: 378px;
      background: #232429;
      overflow: hidden;
      position: relative;
      cursor: pointer;
      .imgbox {
        width: calc(100% - 10px);
        height: 310px;
        margin: 5px 5px 0;
        overflow: hidden;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
        transition: transform 0.6s ease;
        &:hover {
          transform: scale(1.1);
        }
      }

      h1 {
        font-size: 20px;
        line-height: 30px;
        height: 60px;
        font-weight: 400;
        color: #fff;
        margin: 30px 0 0;
        padding: 0 24px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* 控制显示的行数 */
        overflow: hidden; /* 隐藏溢出的内容 */
        text-overflow: ellipsis; /* 显示省略号 */
        &:hover {
          color: #009ade;
        }
      }
      .more {
        font-size: 20px;
        padding-top: 24px;
      }
      p {
        font-size: 18px;
        line-height: 32px;
        font-weight: 400;
        text-align: left;
        color: #999999;
        padding: 0 24px;
        margin: 25px 0 0;
        height: 70px;
      }
      // .righticon {
      //   position: absolute;
      //   width: 16px;
      //   height: 16px;
      //   background-image: url("~@/assets/img/right2.png");
      //   background-size: 100% 100%;
      //   bottom: 40px;
      //   right: 24px;
      //   opacity: 0;
      // }
      // .righticon2 {
      //   animation-name: flyIn; /* 动画名称 */
      //   animation-duration: 0.6s; /* 动画持续时间 */
      //   animation-fill-mode: forwards; /* 动画结束后保留最后一个关键帧的样式 */
      // }
    }
  }
}

::v-deep .videoDialog {
  background: none;
  width: 1405px;
  height: 791px;
  position: relative;
  .el-dialog__header {
    background: none;
    position: absolute;
    top: 40px;
    right: 0px;
    z-index: 9999;
  }
  .el-dialog__body {
    // background: rgba(0, 0, 0, 0.3);
    background: none;
    width: 1405px;
    height: 791px;
    overflow: hidden;
  }

  video {
    width: 1405px;
    height: 791px;
    display: block;
    margin: auto;
  } /* 设置控制栏的高度 */

  // .el-dialog__close {
  //   font-size: 45px;
  // }
}

@media (max-width: 720px) {
  .news {
    display: block;
  }
}

@keyframes flyIn {
  from {
    /* 动画开始时的状态 */
    right: 100px;
    opacity: 0; /* 开始时透明度为0 */
  }
  to {
    /* 动画结束时的状态 */
    right: 24px; /* 结束时元素移动到右边100%的位置 */
    opacity: 1; /* 结束时完全可见 */
  }
}

.animate {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.bottom-spacing {
  height: 60px;
}

.animate-on-scroll {
  opacity: 1;
  transform: translateY(0);
}

.swiper-container {
  width: 1920px;
  height: 1080px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
  }

  img {
    width: 1920px;
    height: 1080px;
  }
}

.swiper-pagination {
  bottom: 40px;
}

::v-deep .swiper-pagination-bullet {
  background: #666;
  opacity: 1;
}

::v-deep .swiper-pagination-bullet-active {
  background: #009ade;
}
</style>
